import { GoCheckCircle } from "react-icons/go";
import { useEffect, useState } from "react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

import AppLogo from "@/assets/img/logo_text_horizontal.png";
import EstimeoLogo from "@/assets/img/estimeo_logo_horizontal.png";

const Success = () => {
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    // Redirect to WordPress success page for GA tracking after 2.2 seconds
    setIsRedirecting(true);
    const timer = setTimeout(() => {
      // Use window.parent.location to break out of iframe and redirect at browser level
      window.parent.location.href = "https://www.linkera.com/page-formulaire-de-contact-confirme";
    }, 2200);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="flex flex-col px-8 py-16 w-[42rem] justify-center bg-white">
      <div className="flex items-center mb-2">
        <div className="w-24 mb-4">
          <img className="w-full drop-shadow-md" src={AppLogo} alt="App Logo" />
        </div>
        <div className="text-5xl text-gray-700 font-medium mb-3 ml-1 mr-2">&times;</div>
        <div className="w-32 mb-4">
          <img className="w-full drop-shadow-md" src={EstimeoLogo} alt="Estimeo Logo" />
        </div>
      </div>
      <div className="flex flex-col items-start space-y-4">
        <h1 className="flex items-center text-2xl gap-2 text-primary font-semibold">
          <span className="text-4xl text-green-700 rounded-full bg-green-100">
            <GoCheckCircle />
          </span>
          Données de valorisation envoyées avec succès !
        </h1>
        <p className="text-sm text-gray-700 font-medium">Merci d'avoir soumis vos données de valorisation, notre équipe les examinera et vous répondra sous peu.</p>
        <div className="flex gap-2 items-center">
          <p className="text-sm text-gray-700 font-medium">Vous allez recevoir un email avec les résultats de votre valorisation.</p>
        </div>
        <div>
          {isRedirecting && (
            <div className="flex items-center gap-2">
              <span className="animate-spin text-gray-500">
                <AiOutlineLoading3Quarters />
              </span>
              <span className="text-sm text-gray-500 font-semibold">Redirection en cours...</span>
            </div>
          )}
          <p className="text-xs text-gray-500 font-medium">Vous serez redirigé automatiquement vers la page de confirmation dans quelques secondes.</p>
        </div>
      </div>
    </div>
  );
};

export default Success;
